import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Button } from "@mui/material";
import FlightOps from "../../assets/images/eTechLog.png";
import Blog from "../../assets/images/etl-page/ReadOurBlog-DiscoverMore.png";
import Brochure from "../../assets/images/etl-page/ViewOurBrochure-DiscoverMore.png";
import ETLBrochure from "../../assets/pdfs/The REDiFly e-Techlog Brochure 2024.pdf";
import { NavLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import SMS from "../../assets/images/sms_snippet.png";

const PREFIX = "DiscoverSection";
const classes = {
  mainGrid: `${PREFIX}-mainGrid`,
  mainHeadingGrid: `${PREFIX}-mainHeadingGrid`,
  mainHeading: `${PREFIX}-mainHeading`,
  discoverItemGridContainer: `${PREFIX}-discoverItemGridContainer`,
  discoverItemGrid: `${PREFIX}-discoverItemGrid`,
  discoverItemMainImageGrid: `${PREFIX}-discoverItemMainImageGrid`,
  discoverItemGridImage: `${PREFIX}-discoverItemGridImage`,
  discoverLink: `${PREFIX}-discoverLink`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`&.MuiGrid2-container`]: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: "5rem",
  },
  [`& .${classes.mainHeadingGrid}`]: {
    paddingTop: "0rem",
    paddingBottom: "1rem",
  },
  [`& .${classes.mainHeading}`]: {
    fontFamily: "AvenirLTStd-Roman",
    fontSize: 40,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      fontSize: 30,
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: 35,
    },
    [theme.breakpoints.between("md", "lg")]: {
      fontSize: 40,
    },
  },
  [`& .${classes.discoverItemGridContainer}`]: {
    margin: "auto",
    paddingTop: "3rem",
    padding: "1%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  [`& .${classes.discoverItemGrid}`]: {
    display: "flex",
    margin: "auto",
    maxWidth: "15rem",
    height: "15.5rem",
    backgroundColor: "#fefbfb",
    borderRadius: "1.5rem",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "1.4em",
    marginBottom: "1rem",
    [theme.breakpoints.down("sm")]: {
      alignItems: "left",
    },
    [theme.breakpoints.down("md")]: {
      alignItems: "left",
    },
  },
  [`& .${classes.discoverItemMainImageGrid}`]: {
    display: "flex",
    justifyContent: "center",
  },
  [`& .${classes.discoverItemGridImage}`]: {
    width: 230,
    height: 230,
  },
  [`& .${classes.discoverLink}`]: {
    marginTop: "1em",
    marginLeft: "1.8em",
    fontSize: 19,
    color: "#cc0000",
    textDecoration: "underline",
    letterSpacing: 0,
    width: "100%",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",
      fontWeight: 500,
    },
  },
}));

const DiscoverSection = () => {
  const handleDownloadClick = () => {
    const pdfFile = ETLBrochure;
    const anchor = document.createElement("a");
    anchor.href = pdfFile;
    anchor.download = "REDiFly eTechlog Brochure - 2024";
    anchor.click();
  };

  return (
    <StyledGrid container className={classes.mainGrid} flexDirection={"column"}>
      <Grid size={{ xs: 12 }} className={classes.mainHeadingGrid}>
        <Typography className={classes.mainHeading}>Discover More</Typography>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Grid container className={classes.discoverItemGridContainer} spacing={2}>
          <Grid
            size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}
            className={classes.discoverItemGrid}
          >
             <Grid className={classes.discoverItemMainImageGrid}>
              <img
                alt="aircraft technician in yellow vest carrying out an inspection"
                src={FlightOps}
                className={classes.discoverItemGridImage}
              />
            </Grid>
            <Typography variant="body2">
              <NavLink to="/etl" className={classes.discoverLink}>
                {" "}
                e-Techlog{" "}
              </NavLink>
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}
            className={classes.discoverItemGrid}
          >
            <Grid className={classes.discoverItemMainImageGrid}>
              <img
                alt="aircraft technician in yellow vest carrying out an inspection"
                src={SMS}
                className={classes.discoverItemGridImage}
              />
            </Grid>
            <Typography variant="body2">
              <NavLink to="/sms" className={classes.discoverLink}>
                {" "}
                SMS Software{" "}
              </NavLink>
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}
            className={classes.discoverItemGrid}
          >
            <Grid className={classes.discoverItemMainImageGrid}>
              <img
                alt="aircraft technician in yellow vest carrying out an inspection"
                src={Blog}
                className={classes.discoverItemGridImage}
              />
            </Grid>
            <Typography variant="body2">
              <NavLink to="/blog" className={classes.discoverLink}>
                {" "}
                Read Our Blog{" "}
              </NavLink>
            </Typography>
          </Grid>
          <Grid
            size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }}
            className={classes.discoverItemGrid}
          >
            <Grid className={classes.discoverItemMainImageGrid}>
              <img
                alt="aircraft technician in yellow vest carrying out an inspection"
                src={Brochure}
                className={classes.discoverItemGridImage}
              />
            </Grid>
            <Typography variant="body2">
              <a onClick={handleDownloadClick} className={classes.discoverLink}>
                {" "}
                View Our Brochure{" "}
              </a>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </StyledGrid>
  );
};

export default DiscoverSection;
